import React from 'react';
import './Header.css';

const Header = () => {
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
        <div className="container">
          <a className="navbar-brand" href="#inicio" onClick={() => handleScroll('inicio')}>
            <img src="/Logo.svg" alt="SerBusiness Logo" className="navbar-logo" />
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item"><a className="nav-link active" href="#inicio" onClick={() => handleScroll('inicio')}>Inicio</a></li>
              <li className="nav-item"><a className="nav-link" href="#services" onClick={() => handleScroll('services')}>Servicios</a></li>
              <li className="nav-item"><a className="nav-link" href="#portfolio" onClick={() => handleScroll('portfolio')}>Portafolio</a></li>
              <li className="nav-item"><a className="nav-link" href="#casos-de-exito" onClick={() => handleScroll('casos-de-exito')}>Casos de Éxito</a></li>
              <li className="nav-item"><a className="nav-link" href="#blog" onClick={() => handleScroll('blog')}>Blog</a></li>
              <li className="nav-item"><a className="nav-link" href="#contact" onClick={() => handleScroll('contact')}>Contacto</a></li>
            </ul>
            <a href="#contact" className="btn btn-primary ms-lg-3" onClick={() => handleScroll('contact')}>Cotiza tu proyecto</a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
